const moduleName = 'addToRequest';

export function addToRequest() {

    Array.from(document.querySelectorAll('.js-add-to-request')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const button = self;
        const checkbox = document.getElementById(button.dataset.id);
        const popupId = button.dataset.popup;

        button.addEventListener('click', () => {
            const item = checkbox.parentNode;
            const list = item.parentNode;

            checkbox.checked = true;
            list.removeChild(item);
            list.insertBefore(item, list.firstChild);
            popup().open(popupId);
        });
    });

}